module.exports = __webpack_public_path__ + "img/cc3623_center_003.e182a793.png";